/* Greatly Social – FilePickerModal  (v2.0 – modernized UI)
   All logic identical to v1.2
------------------------------------------------------------------ */
import React, { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import { FolderFill } from 'react-bootstrap-icons'

const niceName = raw => {
  let n = raw.replace(/\/$/, '').split('/').pop()
  if (n === 'render') n = 'Edited Videos'
  if (n === 'stock')  n = 'Stock Media'
  if (n === 'edited') n = 'Edited Photos'
  return n
}

export default function FilePickerModal ({ show, onClose, onFilesSelect }) {
  const [userId,      setUserId]    = useState(null)
  const [currentPath, setCurrent]   = useState('')
  const [subfolders,  setSubfolders]= useState([])
  const [s3Files,     setS3Files]   = useState([])
  const [selected,    setSelected]  = useState(new Set())
  const [uploadMsg,   setUploadMsg] = useState('')
  const [uploadPct,   setUploadPct] = useState(null)
  const [filter,      setFilter]    = useState('all')
  const [dragOver,    setDragOver]  = useState(null)

  const fileInputRef = useRef(null)

  useEffect(() => {
    if (!show) return
    ;(async () => {
      const r = await fetch('/api/auth/me', { credentials: 'include' })
      const d = await r.json()
      if (d?.user?.id) setUserId(d.user.id)
    })()
  }, [show])

  useEffect(() => { if (show && userId) fetchS3() }, [show, userId, currentPath])

  async function fetchS3 () {
    try {
      const { data } = await axios.get('/api/files', { params:{ userId, prefix:currentPath }, withCredentials:true })
      setSubfolders((data.subfolders||[]).filter(p => !p.endsWith('/avatars/')))
      setS3Files(data.files||[])
      setSelected(new Set())
    } catch (e) { console.error('list S3', e) }
  }

  async function handleUpload (e) {
    try {
      const files = Array.from(e.target.files)
      if (!files.length || !userId) return
      for (const file of files) {
        setUploadMsg(`Uploading "${file.name}"…`)
        setUploadPct(0)
        const { data:{ url, fields } } = await axios.get('/api/generate-presigned', {
          params:{ userId, fileName:file.name, prefix:currentPath, contentType:file.type },
          withCredentials:true,
        })
        const fd = new FormData()
        Object.entries(fields).forEach(([k,v]) => fd.append(k,v))
        if (!('Content-Type' in fields)) fd.append('Content-Type', file.type)
        fd.append('file', file)
        await axios.post(url, fd, {
          onUploadProgress: ev => { if (ev.total) setUploadPct(Math.round(ev.loaded/ev.total*100)) }
        })
      }
      setUploadMsg('Upload complete!')
      setUploadPct(null)
      if (fileInputRef.current) fileInputRef.current.value = ''
      fetchS3()
      setTimeout(() => setUploadMsg(''), 3000)
    } catch (e) {
      console.error('upload failed', e)
      setUploadMsg('Upload failed')
      setUploadPct(null)
    }
  }

  const isImg = f => /\.(jpe?g|png|gif)$/i.test(f.url)
  const isVid = f => /\.(mp4|mov|webm|avi)$/i.test(f.url)
  const filtered = s3Files.filter(f => filter==='all' ? true : filter==='photo' ? isImg(f) : isVid(f))
  const toggle = key => setSelected(prev => { const n = new Set(prev); n.has(key) ? n.delete(key) : n.add(key); return n })
  const addSelected = () => onFilesSelect?.(filtered.filter(f => selected.has(f.key)))
  const goUp = () => { const parts=currentPath.replace(/\/$/,'').split('/'); parts.pop(); setCurrent(parts.length?parts.join('/')+'/':'') }

  if (!show) return null

  return (
    <>
      {/* Backdrop */}
      <div onClick={onClose} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.45)', zIndex:1050, backdropFilter:'blur(2px)' }} />

      {/* Panel */}
      <div style={{
        position    : 'fixed',
        top         : '50%',
        left        : '50%',
        transform   : 'translate(-50%, -50%)',
        zIndex      : 1051,
        background  : '#ffffff',
        borderRadius: 16,
        width       : 760,
        maxWidth    : 'calc(100vw - 32px)',
        maxHeight   : '90vh',
        display     : 'flex',
        flexDirection:'column',
        boxShadow   : '0 20px 60px rgba(0,0,0,0.18)',
        overflow    : 'hidden',
      }}>
        {/* Header */}
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'18px 22px 14px', borderBottom:'1px solid #f3f4f6' }}>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <div style={{ width:32, height:32, borderRadius:'50%', background:'#eff6ff', display:'flex', alignItems:'center', justifyContent:'center' }}>
              <i className='fas fa-folder-open' style={{ fontSize:13, color:'#2563eb' }} />
            </div>
            <h3 style={{ fontSize:16, fontWeight:800, color:'#111827', margin:0 }}>Select Media</h3>
          </div>
          <button type='button' onClick={onClose} style={{ background:'transparent', border:'none', cursor:'pointer', color:'#9ca3af', fontSize:20 }}>×</button>
        </div>

        {/* Toolbar */}
        <div style={{ padding:'12px 22px', borderBottom:'1px solid #f3f4f6', display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
          {/* Back button */}
          {currentPath && (
            <button type='button' onClick={goUp} style={{ display:'flex', alignItems:'center', gap:6, padding:'7px 12px', borderRadius:8, border:'1.5px solid #e5e7eb', background:'transparent', color:'#374151', fontSize:12, fontWeight:600, cursor:'pointer' }}>
              <i className='fas fa-arrow-left' style={{ fontSize:10 }} /> Back
            </button>
          )}
          {currentPath && (
            <div style={{ fontSize:12, fontWeight:600, color:'#6b7280', background:'#f3f4f6', borderRadius:6, padding:'4px 10px' }}>
              <i className='fas fa-folder' style={{ color:'#f59e0b', marginRight:5, fontSize:10 }} />
              {currentPath.replace(/\/$/, '').split('/').pop()}
            </div>
          )}

          <div style={{ marginLeft:'auto', display:'flex', gap:8, alignItems:'center' }}>
            {/* Filter toggle */}
            <div style={{ display:'flex', background:'#f3f4f6', borderRadius:8, padding:3 }}>
              {['all','photo','video'].map(v => (
                <button key={v} type='button' onClick={() => setFilter(v)} style={{
                  padding:'5px 10px', borderRadius:6, border:'none',
                  background: filter===v ? '#ffffff' : 'transparent',
                  color: filter===v ? '#111827' : '#6b7280',
                  fontWeight: filter===v ? 700 : 500, fontSize:12, cursor:'pointer',
                  boxShadow: filter===v ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                }}>
                  {v==='all' ? 'All' : v==='photo' ? '🖼 Photos' : '🎬 Videos'}
                </button>
              ))}
            </div>

            <button type='button' onClick={() => fileInputRef.current?.click()} style={{
              display:'flex', alignItems:'center', gap:6,
              padding:'7px 14px', borderRadius:8, border:'none',
              background:'#2563eb', color:'#fff', fontSize:12, fontWeight:700, cursor:'pointer',
            }}>
              <i className='fas fa-upload' style={{ fontSize:10 }} /> Upload
            </button>
            <input ref={fileInputRef} type='file' multiple accept='image/*,video/*' style={{ display:'none' }} onChange={handleUpload} />
          </div>
        </div>

        {/* Upload progress */}
        {(uploadPct !== null || uploadMsg) && (
          <div style={{ padding:'10px 22px', background:'#f8fafc', borderBottom:'1px solid #e5e7eb', display:'flex', alignItems:'center', gap:10 }}>
            <i className={uploadPct !== null ? 'fas fa-cloud-upload-alt' : 'fas fa-check-circle'} style={{ color: uploadPct !== null ? '#2563eb' : '#16a34a', fontSize:14 }} />
            <div style={{ flex:1 }}>
              <div style={{ fontSize:12, fontWeight:600, color:'#374151', marginBottom: uploadPct !== null ? 4 : 0 }}>{uploadMsg}</div>
              {uploadPct !== null && (
                <div style={{ height:4, borderRadius:99, background:'#e5e7eb', overflow:'hidden' }}>
                  <div style={{ height:'100%', borderRadius:99, background:'#2563eb', width:`${uploadPct}%`, transition:'width 0.2s' }} />
                </div>
              )}
            </div>
            {uploadPct !== null && <span style={{ fontSize:11, fontWeight:700, color:'#2563eb' }}>{uploadPct}%</span>}
          </div>
        )}

        {/* Body */}
        <div style={{ flex:1, overflowY:'auto', padding:'16px 22px' }}>

          {/* Folders */}
          {subfolders.length > 0 && (
            <div style={{ marginBottom:20 }}>
              <div style={{ fontSize:11, fontWeight:700, textTransform:'uppercase', letterSpacing:'0.07em', color:'#9ca3af', marginBottom:10 }}>Folders</div>
              <div style={{ display:'flex', flexWrap:'wrap', gap:10 }}>
                {subfolders.map(p => (
                  <div
                    key={p}
                    onClick={() => setCurrent(p.replace(`${userId}/`, ''))}
                    onMouseEnter={() => setDragOver(p)}
                    onMouseLeave={() => setDragOver(null)}
                    style={{
                      display:'flex', flexDirection:'column', alignItems:'center', gap:5,
                      padding:'12px 10px 8px', borderRadius:10, width:86, cursor:'pointer',
                      background: dragOver===p ? '#eff6ff' : '#ffffff',
                      border:`1.5px solid ${dragOver===p ? '#2563eb' : '#e5e7eb'}`,
                      transition:'all 0.15s', boxShadow:'0 1px 3px rgba(0,0,0,0.05)',
                    }}
                  >
                    <FolderFill size={30} color='#f59e0b' />
                    <div style={{ fontSize:11, fontWeight:600, color:'#374151', textAlign:'center', wordBreak:'break-word', lineHeight:1.3 }}>{niceName(p)}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Files */}
          <div>
            <div style={{ fontSize:11, fontWeight:700, textTransform:'uppercase', letterSpacing:'0.07em', color:'#9ca3af', marginBottom:10 }}>
              Files {filtered.length > 0 && <span style={{ background:'#f3f4f6', borderRadius:99, padding:'1px 7px', color:'#6b7280' }}>{filtered.length}</span>}
            </div>

            {filtered.length ? (
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(100px, 1fr))', gap:10 }}>
                {filtered.map(f => {
                  const isSel = selected.has(f.key)
                  return (
                    <div
                      key={f.key}
                      onClick={() => toggle(f.key)}
                      style={{
                        position:'relative', borderRadius:10, overflow:'hidden', cursor:'pointer',
                        border:`2px solid ${isSel ? '#2563eb' : 'transparent'}`,
                        boxShadow: isSel ? '0 0 0 3px rgba(37,99,235,0.2)' : '0 1px 3px rgba(0,0,0,0.08)',
                        aspectRatio:'1', transition:'all 0.15s',
                      }}
                    >
                      {isImg(f)
                        ? <img src={f.url} alt='' style={{ width:'100%', height:'100%', objectFit:'cover', display:'block' }} />
                        : <video src={f.url} muted loop style={{ width:'100%', height:'100%', objectFit:'cover', display:'block' }} />
                      }
                      {isSel && (
                        <div style={{ position:'absolute', inset:0, background:'rgba(37,99,235,0.35)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                          <div style={{ width:26, height:26, borderRadius:'50%', background:'#2563eb', display:'flex', alignItems:'center', justifyContent:'center', border:'2px solid #fff' }}>
                            <i className='fas fa-check' style={{ fontSize:10, color:'#fff' }} />
                          </div>
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>
            ) : (
              <div style={{ textAlign:'center', padding:'36px 0', color:'#9ca3af', fontSize:13 }}>
                <i className='fas fa-images' style={{ fontSize:28, display:'block', marginBottom:8, opacity:0.4 }} />
                No files in this folder.
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div style={{ padding:'14px 22px', borderTop:'1px solid #f3f4f6', display:'flex', justifyContent:'space-between', alignItems:'center', gap:10 }}>
          <span style={{ fontSize:13, color:'#6b7280' }}>
            {selected.size > 0 ? `${selected.size} file${selected.size !== 1 ? 's' : ''} selected` : 'Click files to select'}
          </span>
          <div style={{ display:'flex', gap:8 }}>
            <button type='button' onClick={onClose} style={{ padding:'8px 16px', borderRadius:8, border:'1.5px solid #e5e7eb', background:'transparent', color:'#374151', fontSize:13, fontWeight:600, cursor:'pointer' }}>
              Cancel
            </button>
            <button
              type='button'
              onClick={addSelected}
              disabled={!selected.size}
              style={{
                padding:'8px 18px', borderRadius:8, border:'none',
                background: selected.size ? '#2563eb' : '#e5e7eb',
                color: selected.size ? '#fff' : '#9ca3af',
                fontSize:13, fontWeight:700, cursor: selected.size ? 'pointer' : 'not-allowed',
              }}
            >
              Add Selected ({selected.size})
            </button>
          </div>
        </div>
      </div>
    </>
  )
}